import { makeStyles } from '@mui/styles';
const styles = makeStyles(() => ({
  headerCell: {
    border: '2px solid white',
    backgroundColor: '#cccccc',
    color: 'black',
    fontWeight: 'bold',
    padding: '4px',
    height: '20px'
  },
  rowCell: {
    border: '2px solid white',
    backgroundColor: '#e0e0e0',
    color: 'black',
    padding: '4px',
    height: '20px'
  },
  tableContainer: {
    maxWidth: 300,
    height: 'auto',
    maxHeight: 600
  },
  dialogTitle: {
    lineHeight: '2 !important',
    padding: '8px 10px !important',
  },
  menuTogglerBtn: {
    position: 'absolute',
    bottom: '23vh',
    zIndex: 2000,
    right: '-20px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  menuTogglerTableBtn: {
    position: 'absolute',
    bottom: '23vh',
    zIndex: 2000,
    right: '40.70%',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
    '&:hover': {
      backgroundColor: '#c3c3c3',
    },
  },
  titleHeader: {
    fontWeight: 'bold',
    fontSize: '1.3rem'
  },
  boxStyle: {
    overflow: 'auto',
    marginTop: '-2%'
  },
  iconSize: {
    fontSize: '33px'
  },
  progressBarStyle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '700px'
  },
  gridContainer: {
    paddingTop: '4px',
    borderBottom: '1px solid #ccc'
  },
  gridItem: {
    background: '#F2F2F2',
    paddingBottom: '1px',
    borderBottom: '0.5px solid #FFF',
    textAlign: 'center'
  },
  headerName: {
    flex: 0.5,
    fontWeight: 'bold',
    borderRight: '1px solid #ccc'
  },
  accordianScrollUp: {
    position: 'fixed',
    bottom: 10,
    right: 10
  },
  menuTogglerMobileBtn: {
    position: 'absolute',
    bottom: '38vh',
    zIndex: 200,
    right: '-10px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
  },
  menuTogglerMobileTableBtn: {
    position: 'absolute',
    bottom: '38vh',
    zIndex: 200,
    right: '-10px',
    backgroundColor: '#e0e0d1',
    borderRadius: '50%',
  },
}));
export default styles;
